import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import classes from "./Footer.module.css";

export const Footer = ({ translate }) => (
  <div className={classes.footer}>
    <Flex direction="column" middle center className={classes.pageContainer}>
      <span className={classes.footer__mainText}>{translate("Besoin d’aide ?")}</span>
      <span>
        {translate(
          "service.commercial@bluegreen.fr ou tél 01.41.18.65.50 du lundi au jeudi de 9h00 à 18h00 et le vendredi de 9h00 à 17h00"
        )}
      </span>
    </Flex>
  </div>
);

Footer.propTypes = {
  translate: PropTypes.func.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/Footer/Footer.js